import { useState, useEffect } from "react";
import { useToastPromise } from "../../components/toastPromise";
import { ContactUsController } from "../../controllers/contactUsController";
import "../../assets/css/contactUs.css";
import { ContactUs } from "./contactUs";
import { TableList } from "../../components/tableList";

export const AllContactUs = ({ user }) => {
  const toastPromise = useToastPromise();
  const [loading, setLoading] = useState(false);
  const [contactUsList, setContactUsList] = useState([]);
  const [isOpen, setIsOpen] = useState(false);
  const [selectedData, setSelectedData] = useState(null);
  useEffect(() => {
    getAll();
  }, []);
  const getAll = () => {
    setLoading(true);
    toastPromise({
      promise: new Promise((resolve, reject) => {
        ContactUsController.getAll({
          resolve: resolve,
          reject: reject,
        });
      }),
      successMessage: (data) => {
        const fetchedData = data.docs.map((doc) => ({
          ...doc.data(),
          id: doc.id,
        }));
        setContactUsList(fetchedData);
        return "Contact us details retrieved successfully.";
      },
      errorMessage: (data) => data,
    }).finally(() => setLoading(false));
  };
  const handleDeleteSelected = (selectedRows, success) => {
    setLoading(true);
    toastPromise({
      promise: new Promise((resolve, reject) => {
        ContactUsController.deleteAll({
          idList: selectedRows,
          resolve: resolve,
          reject: reject,
        });
      }),
      successMessage: success,
      errorMessage: (data) => data,
    }).finally(() => setLoading(false));
  };
  const handlePopupDialogOpen = (contactUs = null) => {
    setSelectedData(contactUs);
    setIsOpen(true);
  };
  const handleClose = () => {
    setIsOpen(false);
  };

  return (
    <section id="contactUsList">
      <h4>CONTACT US LISTS</h4>
      <hr />
      <TableList
        loading={loading}
        list={contactUsList}
        handlePopupDialogOpen={handlePopupDialogOpen}
        deletePromise={(selectedRows, success) => {
          handleDeleteSelected(selectedRows, success);
        }}
      />
      <ContactUs
        user={user}
        isOpen={isOpen}
        handleClose={handleClose}
        getAll={getAll}
        selectedData={selectedData}
      />
    </section>
  );
};
